import { Tooltip } from "@mui/material";
import { Box } from "@mui/material";
import WarningIcon from '@mui/icons-material/Warning';


const WarningTooltipIcon = ({ content } : 
    {content: any} 
) => {
    return(

            <Tooltip 
                placement="right-start"
                disableInteractive={false}
                sx={{ border: "2px solid #aaa", opacity: 1, zIndex: 1000 }}
                title={content}
            >
                <span 
                    style={{
                        cursor: "pointer",
                        color: '#777',
                        fontSize: '14px',
                        }}>
                        <Box sx={{ 
                            position: 'relative', 
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <Box sx={{
                                position: 'absolute',
                                width: '6px',
                                height: '6px',
                                borderRadius: '50%',
                                backgroundColor: 'black',
                                zIndex: 0,
                                top: '40%',
                            }}/>
                            <WarningIcon sx={{color: 'orange', position: 'relative', zIndex: 1, fontSize: '16px'}}/>
                        </Box>
                </span>
            
            </Tooltip>
    );
}

export default WarningTooltipIcon;